import fileDownload from "js-file-download";
import LaddersAPI from "../api/ladders";

// eslint-disable-next-line import/prefer-default-export
export const download = async (clubId, seasonId, id, fileName) => {
  const data = await LaddersAPI.download(clubId, seasonId, id);
  fileDownload(data.data, fileName);
};
